// Presets used by RoomCard add-buttons + extras list.
// Aligned with v6 price code schema (2026-02-11).
// `description` must match ROOM_DEFAULTS action labels so RoomQuickFlow can
// fold detail-mode additions back into the checklist (matching by code is
// primary via the v5.3 action_code self-heal — description is fallback only).
export const WALL_PRESET    = { code: "S-03.01", formula: "wall",    label: "Wand",    description: "Muren schilderen" };
export const CEILING_PRESET = { code: "S-03.03", formula: "ceiling", label: "Plafond", description: "Plafond schilderen" };
export const FLOOR_PRESET   = { code: null,      formula: "floor",   label: "Vloer",   description: "Vloer" };
export const DOOR_PRESET    = { code: "S-04.01", formula: "piece",   label: "Deur",    description: "Deuren lakken" };
export const WINDOW_PRESET  = { code: "S-04.05", formula: "piece",   label: "Raam",    description: "Ramen lakken" };

export const EXTRA_PRESETS = [
  { code: "S-01.01", label: "Beschermen + afplakken" },
  { code: "S-01.04", label: "Reinigen / ontvetten" },
  { code: "S-01.05", label: "Schuren licht" },
  { code: "S-02.01", label: "Plamuren licht" },
  { code: "S-02.02", label: "Plamuren medium" },
  { code: "S-03.05", label: "Primer muren" },
  { code: "S-03.06", label: "Primer plafonds" },
];
